import { useState } from "react"
import { H2 } from "components/ui/typography/titles/Titles"
import { TableModelNumbers } from "./layout/TableModelNumbers/TableModelNumbers"
import { ButtonPrimary } from "components/ui/buttons/ButtonPrimary/ButtonPrimary"
import { AddModelNumberModal } from "./layout/AddModelNumberModal/AddModelNumberModal"
import { DrawerModelNumber } from "./layout/DrawerModelNumber/DrawerModelNumber"
import style from "./ModelNumbers.module.scss"

const { modelNumbers, top, addModelNumberButton } = style

export const ModelNumbers = () => {
	const [isModalOpen, setModalOpen] = useState(false)

	return (
		<>
			<div className={modelNumbers}>
				<div className={top}>
					<H2>Cabinet model numbers</H2>
					<ButtonPrimary className={addModelNumberButton} onClick={() => setModalOpen(true)}>
						Add model number
					</ButtonPrimary>
				</div>
				<TableModelNumbers />
			</div>
			<AddModelNumberModal isModalOpen={isModalOpen} setModalClose={() => setModalOpen(false)} />
			<DrawerModelNumber />
		</>
	)
}
